/**
=========================================================
* Annotation Portal React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/**
  The hexToRgb() function helps you to change the hex color code to rgb,
  e.g. "#1A73E8" -> "26, 115, 232". Replaces chroma-js (~40 KB) for the only
  formats the theme uses: #rgb, #rrggbb, #rrggbbaa, rgb()/rgba() and a few names.
 */

const NAMED_COLORS = { transparent: "0, 0, 0", black: "0, 0, 0", white: "255, 255, 255" };

function hexToRgb(color) {
  const value = String(color).trim().toLowerCase();

  if (NAMED_COLORS[value]) return NAMED_COLORS[value];

  const rgbMatch = value.match(/^rgba?\(\s*(\d+)[\s,]+(\d+)[\s,]+(\d+)/);
  if (rgbMatch) return rgbMatch.slice(1, 4).join(", ");

  let hex = value.replace(/^#/, "");
  if (hex.length === 3 || hex.length === 4) {
    hex = hex
      .slice(0, 3)
      .split("")
      .map((c) => c + c)
      .join("");
  }

  if (!/^[0-9a-f]{6}([0-9a-f]{2})?$/.test(hex)) return "0, 0, 0";

  return [0, 2, 4].map((i) => parseInt(hex.slice(i, i + 2), 16)).join(", ");
}

export default hexToRgb;
